module.exports = __webpack_public_path__ + "assets/img/INTERIOR1.f3016797.png";